import { useEffect, useState } from "react";

export function useIsScrolledPast(threshold: number): boolean {
  const [isPast, setIsPast] = useState(
    typeof window !== "undefined" ? window.scrollY > threshold : false
  );

  useEffect(() => {
    let ticking = false;
    let rafId: number | null = null;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      rafId = requestAnimationFrame(() => {
        setIsPast((prev) => {
          const next = window.scrollY > threshold;
          return prev === next ? prev : next;
        });
        ticking = false;
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [threshold]);

  return isPast;
}
